import React, { useState } from 'react';
import {
  SCTopBarContainer,
  SCTopBarLabel,
  SCTopBarLabelWrapper,
  SCToggleButton, SCButtonIcon,
} from './styled'
import collapseOpenImg from '../../../../../public/static/ra/collapse-open.svg'
import collapseCloseImg from '../../../../../public/static/ra/collapse-close.svg'
import { useTranslation } from 'react-i18next';


interface TopBarProps {
  label: string;
}

const TopBarCollapsible = ({ label }: TopBarProps) => {
  const { t } = useTranslation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <SCTopBarContainer $collapsed={isCollapsed}>
      {!isCollapsed && (
        <SCTopBarLabelWrapper>
          <SCTopBarLabel>{label}</SCTopBarLabel>
        </SCTopBarLabelWrapper>
      )}
      <SCToggleButton onClick={() => setIsCollapsed((prev) => !prev)}>
        {isCollapsed ? <SCButtonIcon src={collapseOpenImg.src} alt={t('augmentedReality.topBar.collapseAlt')} style={{ transform: 'rotate(180deg)' }} /> : <SCButtonIcon src={collapseCloseImg.src} alt={t('augmentedReality.topBar.expandAlt')} />}
      </SCToggleButton>
    </SCTopBarContainer>
  );
};

export default TopBarCollapsible;
